import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  totalDocuments: number
  filename: string
  loading: boolean
  onSubmit: () => void
  onClose: () => void
  useF0?: boolean
}

const RestoreModal = ({
  totalDocuments,
  loading,
  filename,
  onSubmit,
  onClose,
  useF0 = false,
}: Props) => {
  if (useF0) {
    return (
      <F0Dialog
        isOpen
        width="sm"
        title={i18n.tp('documents.trash_bin.restore.title', { count: totalDocuments })}
        onClose={onClose}
        primaryAction={{
          label: i18n.t('documents.trash_bin.restore.confirm'),
          onClick: onSubmit,
          loading,
        }}
        secondaryAction={{
          label: i18n.t('common.cancel'),
          onClick: onClose,
        }}
      >
        <F0Box display="flex" flexDirection="column" gap="xl">
          <F0Text
            variant="body"
            content={i18n.tp('documents.trash_bin.restore.description', {
              count: totalDocuments,
              name: filename,
            })}
          />
        </F0Box>
      </F0Dialog>
    )
  }

  return (
    <Modal
      title={i18n.tp('documents.trash_bin.restore.title', { count: totalDocuments })}
      description={i18n.tp('documents.trash_bin.restore.description', {
        count: totalDocuments,
        name: filename,
      })}
      illustration="history"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button
            type="negative"
            submit
            loading={loading}
            iconName={loading ? 'delete' : undefined}
          >
            {i18n.t('documents.trash_bin.restore.confirm')}
          </Button>
        </>
      }
    />
  )
}

export default RestoreModal
